<template>
  <HeaderBase>
    <div
      class="flex items-center header-title cursor-pointer w-1/5"
      @click="$router.back()">
      <span class="arrow arrow-l arrow-primary"></span>
      <span>
        <b>Заказ:</b>
        <b class="text-muted">
          {{ order.name }}
        </b>
      </span>
    </div>
    <div class="flex flex-row space-x-6 order-header-meta">
      <div class="flex flex-col space-y-2">
        <div class="flex flex-row items-center space-x-1">
          <span class="text-14px leading-16px text-muted">Создан:</span>
          <b class="text-14px leading-16px">
            {{ moment($delve(order, 'createdAt')).format('DD.MM.YYYY') }}
          </b>
        </div>
        <div class="flex flex-row items-center space-x-1">
          <span class="text-14px leading-16px text-muted">Стоимость:</span>
          <b class="text-14px leading-16px">
            {{ $numeral(parseFloat($delve(order, 'price'))).format('0,0 $') }}
          </b>
        </div>
        <div class="flex flex-row items-center space-x-1">
          <span class="text-14px leading-16px text-muted">Доход партнёра:</span>
          <b class="text-14px leading-16px">
            {{ $delve(order, 'contractorPrice') != null
              ? $numeral(parseFloat($delve(order, 'contractorPrice'))).format('0,0.00 $')
              : '—' }}
          </b>
        </div>
      </div>
      <div class="flex flex-col space-y-2">
        <div
          class="flex flex-row items-center space-x-1"
          v-if="$delve(order, 'customer')">
          <span class="text-14px leading-16px text-muted">Заказчик:</span>
          <b
            class="text-14px leading-16px cursor-pointer"
            @click="$router.push({
              name: 'customers.details.info',
              params: {
                id: order.customer.id,
              },
            })">{{ $delve(order, 'customer.name') }}</b>
        </div>
        <div
          class="flex flex-row items-center space-x-1"
          v-if="$delve(order, 'contractor')">
          <span class="text-14px leading-16px text-muted">Исполнитель:</span>
          <b class="text-14px leading-16px cursor-pointer"
            @click="$router.push({
              name: 'contractors.details.info',
              params: {
                id: order.contractor.id,
              },
            })">{{ $delve(order, 'contractor.name') }}</b>
        </div>
      </div>
    </div>
    <div class="flex-grow px-4 flex items-center justify-end order-header-payout">
      <button class="btn btn-sm btn-danger font-normal flex flex-col items-center order-header-payout-button"
              :disabled="waitPending"
              @click="onPayoutClick">
        Принудительная выплата - только при закрытом заказе!
      </button>
    </div>
  </HeaderBase>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { iwalyNotify } from '@/notify';
import HeaderBase from './HeaderBase.vue';

export default {
  components: {
    HeaderBase,
  },
  computed: {
    ...mapGetters({
      orders: 'orders/order',
    }),
    id() {
      return _.get(this.$route, 'params.id');
    },
    order() {
      return this.orders(this.id) || {};
    },
    waitPending() {
      return this.$wait.is(`payout.order.${this.id}`);
    },
  },
  methods: {
    ...mapActions({
      payout: 'orders/ACT_ORDER_PAYOUT',
    }),
    moment(data, format) {
      return moment(data, format);
    },
    async onPayoutClick() {
      // eslint-disable-next-line
      if (window.confirm('Вы уверены, что хотите совершить принудительную выплату за заказ?')) {
        await this.payout(this.id);
        iwalyNotify.success({
          text: 'Выплата успешно совершена!',
        });
      }
    },
  },
};
</script>
